var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDI1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.465,
    height: 227.432,
    viewBox: "0 0 202.465 227.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135332",
    "data-name": "Group 135332",
    transform: "translate(-189 -2415.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_168",
    "data-name": "Line 168",
    d: "M131.7,10.614H4.591A5.519,5.519,0,0,1-.75,4.932,5.519,5.519,0,0,1,4.591-.75H131.7a5.519,5.519,0,0,1,5.341,5.682A5.519,5.519,0,0,1,131.7,10.614Z",
    transform: "translate(220.789 2553.085)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_169",
    "data-name": "Line 169",
    d: "M131.7,10.614H4.591A5.519,5.519,0,0,1-.75,4.932,5.519,5.519,0,0,1,4.591-.75H131.7a5.519,5.519,0,0,1,5.341,5.682A5.519,5.519,0,0,1,131.7,10.614Z",
    transform: "translate(220.789 2588.755)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6007",
    "data-name": "Rectangle 6007",
    d: "M20.261-.75H180.7a21.035,21.035,0,0,1,21.011,21.011v185.41A21.035,21.035,0,0,1,180.7,226.682H20.261A21.035,21.035,0,0,1-.75,205.671V20.261A21.035,21.035,0,0,1,20.261-.75ZM180.7,215.791a10.132,10.132,0,0,0,10.121-10.121V20.261A10.132,10.132,0,0,0,180.7,10.14H20.261A10.132,10.132,0,0,0,10.14,20.261v185.41a10.132,10.132,0,0,0,10.121,10.121Z",
    transform: "translate(189.75 2416.094)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_170",
    "data-name": "Line 170",
    d: "M63.658,10.614H4.932a5.682,5.682,0,0,1,0-11.364H63.658a5.682,5.682,0,1,1,0,11.364Z",
    transform: "translate(220.789 2517.417)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91133",
    "data-name": "Path 91133",
    d: "M201.315,67.978,172.184,38.847a5.682,5.682,0,0,1,8.035-8.035l21.1,21.1,45.1-45.1a5.682,5.682,0,1,1,8.035,8.035Z",
    transform: "translate(109.632 2443.45)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDI1);
export default __webpack_public_path__ + "static/media/d-i-1.57cb606999e13262d3311d991b2bfb73.svg";
export { ForwardRef as ReactComponent };